import { createDialogProvider } from "src/components/Dialog";
import { DuplicateRequestDialogContext } from "./context";
import { DuplicateRequestDialog } from "./DuplicateRequestDialog";

export const { DialogProvider: DuplicateRequestDialogProvider } =
  createDialogProvider(
    DuplicateRequestDialogContext,
    DuplicateRequestDialog,
    "DuplicateRequestDialog"
  );
